var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatepicker from 'react-datepicker';
import DatePickerInput from './DatePickerInput';
import moment from 'moment';
import css from './DatePicker.scss';

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.filterDate = _this.filterDate.bind(_this);
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'filterDate',
    value: function filterDate(date) {
      if (this.props.excludePastDates) {
        if (date < moment().startOf('d')) {
          return false;
        }
      }

      return this.props.filterDate(date);
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props = this.props,
          rtl = _props.rtl,
          style = _props.style,
          theme = _props.theme,
          prefix = _props.prefix,
          inputDataHook = _props.inputDataHook,
          onEnterPressed = _props.onEnterPressed,
          error = _props.error,
          errorMessage = _props.errorMessage,
          customInput = _props.customInput;

      return React.createElement(DatePickerInput, {
        rtl: rtl, style: style, theme: theme, prefix: prefix, dataHook: inputDataHook,
        onEnterPressed: onEnterPressed, error: error, errorMessage: errorMessage,
        customInput: customInput
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: css.wrapper },
        React.createElement(ReactDatepicker, _extends({}, this.props, {
          selected: this.props.value,
          onChange: function onChange(val) {
            if (_this2.filterDate(val)) {
              _this2.props.onChange(val);
            }
          },
          customInput: this.renderInput(),
          filterDate: this.filterDate,
          readOnly: this.props.readOnly,
          showYearDropdown: this.props.showYearDropdown,
          scrollableYearDropdown: true
        }))
      );
    }
  }]);

  return DatePicker;
}(Component);

DatePicker.propTypes = {
  style: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  filterDate: PropTypes.func,
  excludePastDates: PropTypes.bool,
  readOnly: PropTypes.bool,
  showYearDropdown: PropTypes.bool,
  rtl: PropTypes.bool,
  placeholderText: PropTypes.string,
  theme: PropTypes.string,
  prefix: PropTypes.node,
  inputDataHook: PropTypes.string,
  onEnterPressed: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  customInput: PropTypes.node
};
DatePicker.defaultProps = {
  style: {
    width: 150
  },

  filterDate: function filterDate() {
    return true;
  }
};
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/DatePicker/DatePicker.js